import { HttpPromise } from '../../types/http-responses';
import {
  BASE_PATH,
  POLICIES_PATH,
  // SECURITY_GROUPS_PATH,
} from '../../transport/services/config';
import { transport } from '../../transport/transport';

import {
  Permission,
  PermissionCreateDTO,
  RevisionCreateDTO,
} from './permissions.types';

function getPermissions(organizationId: string): HttpPromise {
  return transport.get(`${BASE_PATH}/${organizationId}${POLICIES_PATH}`);
}

function getProjectPermissions(
  organizationId: string,
  projectId: string,
): HttpPromise {
  return transport.get(
    `${BASE_PATH}/${organizationId}/${projectId}${POLICIES_PATH}`,
  );
}

function getPermission({ organizationId, permissionId }): HttpPromise {
  return transport.get(
    `${BASE_PATH}/${organizationId}${POLICIES_PATH}/${permissionId}`,
  );
}

function createPermission({
  permission,
  organizationId,
  projectId,
}: {
  permission: PermissionCreateDTO;
  organizationId: string;
  projectId: string;
}): HttpPromise {
  const url = `${BASE_PATH}/${organizationId}/${projectId}${POLICIES_PATH}`;

  return transport.post(url, permission);
}

function deletePermission({ permissionId, organizationId }): HttpPromise {
  return transport.delete(
    `${BASE_PATH}/${organizationId}${POLICIES_PATH}/${permissionId}`,
  );
}

function activatePermission({
  permission,
  organizationId,
}: {
  permission: Permission;
  organizationId: string;
}): HttpPromise {
  return transport.post(
    `${BASE_PATH}/${organizationId}${POLICIES_PATH}/${permission.id}/activate`,
    permission,
  );
}

function deactivatePermission({
  permission,
  organizationId,
}: {
  permission: Permission;
  organizationId: string;
}): HttpPromise {
  return transport.post(
    `${BASE_PATH}/${organizationId}${POLICIES_PATH}/${permission.id}/deactivate`,
    permission,
  );
}

function updatePermissionName({
  name,
  organizationId,
  permissionId,
}: {
  name: string;
  organizationId: string;
  permissionId: string;
}): HttpPromise {
  return transport.put(
    `${BASE_PATH}/${organizationId}${POLICIES_PATH}/${permissionId}`,
    { name },
  );
}

function getRevisions({
  organizationId,
  permissionId,
}: {
  organizationId: string;
  permissionId: string;
}) {
  return transport.get(
    `${BASE_PATH}/${organizationId}${POLICIES_PATH}/${permissionId}/revisions`,
  );
}

function createRevision({
  revision,
  organizationId,
  permissionId,
}: {
  revision: RevisionCreateDTO;
  organizationId: string;
  permissionId: string;
}) {
  return transport.post(
    `${BASE_PATH}/${organizationId}${POLICIES_PATH}/${permissionId}/revisions`,
    revision,
  );
}

function activateRevision({
  revisionNumber,
  organizationId,
  permissionId,
}: {
  revisionNumber: number;
  organizationId: string;
  permissionId: string;
}) {
  return transport.post(
    `${BASE_PATH}/${organizationId}${POLICIES_PATH}/${permissionId}/revisions/${revisionNumber}/activate`,
  );
}

function getApplicationGroups(organizationId: string) {
  // return transport.get(`${BASE_PATH}/${organizationId}${SECURITY_GROUPS_PATH}`);
  return Promise.resolve();
}

export const permissionService = {
  getPermissions,
  getPermission,
  getProjectPermissions,
  createPermission,
  deletePermission,
  activatePermission,
  deactivatePermission,
  updatePermissionName,

  getRevisions,
  createRevision,
  activateRevision,

  getApplicationGroups,
};
